export default "__VITE_ASSET__DLLl7zPG__"